const getCustomIcon = (code) => {
    return `<img src="icons/${code}" />`
}

export {
    getCustomIcon
}